<template>
  <section class="features-split section" :class="[hasBgColor && 'has-bg-color', invertColor && 'invert-color']">
    <div class="container">
      <div class="features-split-inner section-inner" :class="[topDivider && 'has-top-divider', bottomDivider && 'has-bottom-divider']">
        <c-section-header :data="sectionHeader" class="center-content" />
        <div class="split-wrap" :class="[invertMobile && 'invert-mobile', invertDesktop && 'invert-desktop']">
          <div class="split-item">
            <div class="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
              <h3 class="mt-0 mb-12">
                Keep an eye on your servers
              </h3>
              <p class="m-0">
                SRVControl works anywhere Discord does, so no matter where you are, you can count on SRVControl being available to make sure all your
                servers are online.
              </p>
            </div>
            <div class="split-item-image reveal-from-right" data-reveal-container=".split-item" :class="imageFill && 'split-item-image-fill'">
              <c-image :src="require('@/assets/images/features-split-image.svg')" alt="Features split image 01" :width="528" :height="396" />
              <div style="position:absolute;width:117.8%;max-width:117.8%;top:-9.9%;left:-5.87%;">
                <c-image :src="require('@/assets/images/feature-1.svg')" alt="Features split top 01" :width="622" :height="510" />
              </div>
            </div>
          </div>

          <div class="split-item">
            <div class="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
              <h3 class="mt-0 mb-12">
                Customizable
              </h3>
              <p class="m-0">
                SRVControl can be customized with a logo and color to be shown on messages in your Discord server so you're not limited to our
                branding.
              </p>
            </div>
            <div class="split-item-image reveal-from-left" data-reveal-container=".split-item" :class="imageFill && 'split-item-image-fill'">
              <c-image :src="require('@/assets/images/features-split-image.svg')" alt="Features split image 02" :width="528" :height="396" />
              <div style="position:absolute;width:117.8%;max-width:117.8%;top:-9.9%;left:-5.87%;">
                <c-image :src="require('@/assets/images/feature-2.svg')" alt="Features split top 02" :width="622" :height="510" />
              </div>
            </div>
          </div>

          <div class="split-item">
            <div class="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
              <h3 class="mt-0 mb-12">
                Free to use
              </h3>
              <p class="m-0">
                SRVControl doesn't cost you anything, it's completely free to use and always will be.
              </p>
            </div>
            <div class="split-item-image reveal-from-right" data-reveal-container=".split-item" :class="imageFill && 'split-item-image-fill'">
              <c-image :src="require('@/assets/images/features-split-image.svg')" alt="Features split image 03" :width="528" :height="396" />
              <div style="position:absolute;width:117.8%;max-width:117.8%;top:-9.9%;left:-5.87%;">
                <c-image :src="require('@/assets/images/feature-3.svg')" alt="Features split top 03" :width="622" :height="510" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionSplitProps } from '@/utils/SectionProps.js';
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue';
import CImage from '@/components/elements/Image.vue';

export default {
  name: 'CFeaturesSplit',
  components: {
    CSectionHeader,
    CImage
  },
  mixins: [SectionSplitProps],
  data() {
    return {
      sectionHeader: {
        title: 'Designed for everyone',
        paragraph:
          "SRVControl can be used on any instance of Pterodactyl, it doesn't matter if you're using shared hosting or hosting your own panel."
      }
    };
  }
};
</script>
